import moment, { Moment } from 'moment';
import { PayoutFrequencyEnum, SeasonProcessState, SeasonTypeEnum } from '@coin/shared/core/util-enums';
import { ProcessStepModel, SeasonConfiguration, SeasonPlan } from '@coin/shared/core/util-models';
import { SpecialPaymentSetting } from './season-setting.model';

export class Season {
  id: string;
  title: string;
  description?: string;
  persistenceId?: string;
  ruleSetId?: string;
  assignedToId?: string;
  assignedTo?: Record<string, string>;
  assignedToUserId?: string;
  createDate?: string;
  createdBy?: string;
  lastUpdate?: string | Moment;
  updatedBy?: string;
  version?: number;
  seasonType?: SeasonTypeEnum;
  processSteps?: ProcessStepModel[];
  duplicateSeason?: Season;
  seasonStart: Moment | string = moment.utc('10-01', 'MM-DD');
  seasonEnd: Moment | string = moment.utc('09-30', 'MM-DD').add(1, 'y');
  payoutFrequency?: PayoutFrequencyEnum | string = PayoutFrequencyEnum.YEARLY;
  populationFreezeDate?: string;
  processStepId?: string;
  state?: SeasonProcessState;
  lastRePopulationDate: string;
  plans?: SeasonPlan[];
  settingId?: string;
  seasonConfiguration: SeasonConfiguration;
  latestSeasonSetting?: SpecialPaymentSetting;

  // only FE
  plan?: SeasonPlan;
}
